import dynamic from "next/dynamic";

export const HeroHome = dynamic(() => import("./component"));
